/**
 * Post-login landing page. Single source of truth for PublicRoute (password
 * login) and VerifyPage (magic link).
 *
 * Everyone lands on `/home`. It used to send invoice users to `/invoices`, which
 * meant a patron who had just created his account met an empty invoice table with
 * filters and pagination ("Page 1/1 · 0 facture") and no way to guess what to do
 * next. `/home` carries the profile nudge and "Nouveau chantier" — the two things
 * a first session needs. An invoice user reaches the registry from the menu, one
 * click away.
 */
export function landingPageFor(_user: { permissions?: string[] } | null | undefined): string {
  return '/home'
}
